// this is an autogenerated file from DesignSystem/AppointmentActions/mutation-mark-as-no-show.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_AppointmentActions($id: uuid!) {
  vaxiom_appointment_booking_no_show(id: $id) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
      appointment {
        id
        _id
        estimated_scheduling_date
      }
    }
  }
}

`